import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./SelectFromCategories.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Product_Card from "../Common-Component/Product_Card/Product_Card";
import Popular_Product_Card from "../Common-Component/Popular_Product_Card/Popular_Product_Card";
import { useParams } from "react-router-dom";
import { Context } from "../../utils/context";
import "swiper/css/navigation";
import {
  Category,
  ChildSubCategory,
  Products,
  SubCategory,
} from "../../utils/apis/Product/Product";
import DoubleHeading from "../Common-Component/DoubleHeading/DoubleHeading";
import Filter_btn from "../Common-Component/common_btn/filter_btn/Filter_btn";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../All-Products/filter_offcanvas/Filter_offcanvas";
import Loader_lottie from "../Animation/Loader_lottie/Loader_lottie";
import { ShimmerThumbnail } from "react-shimmer-effects";

const SelectFromCategories = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [numToShow, setNumToShow] = useState(20); // Number of products to show initially
  const [showAll, setShowAll] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [childCategory, setChildCategory] = useState([]);
  const [products, setProducts] = useState([]);
  const { IMG_URL } = useContext(Context);
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const { id } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const sectionRef = useRef(null);

  // Fetch categories on load
  const getCategory = async () => {
    try {
      setShimmerLoader(true);
      const res = await Category();
      if (res?.success) {
        setCategory(res.data);
        getSubCategory(id);
        getProduct("", id);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setShimmerLoader(false);
    }
  };

  // Fetch subcategories for a selected category
  const getSubCategory = async (categoryId) => {
    // setShimmerLoader(true);
    const res = await SubCategory(categoryId);
    if (res?.success) {
      setSubCategory(res.data || []); // Fallback to an empty array if res.data is not an array
    }
    // setShimmerLoader(false);
  };

  const getChildCategory = async (subCategoryId) => {
    const res = await ChildSubCategory(subCategoryId);
    if (res?.success) {
      setChildCategory(res.data);
    }
  };

  const getProduct = async (id, subcategory) => {
    try {
      const res = await Products(id, subcategory);
      if (res?.success) {
        await setProducts(res?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // When a category is clicked, fetch subcategories and products
  const handleCategoryClick = (categoryId) => {
    getSubCategory(categoryId);
    getProduct(categoryId); // Fetch products directly when category is clicked
  };

  // When a subcategory is clicked, fetch child categories and products
  const handleSubCategoryClick = (subCategoryId) => {
    getChildCategory(subCategoryId);
    getProduct("", subCategoryId); // Fetch products for this subcategory
  };

  // Toggle the view for showing all products or fewer
  // const toggleShowAll = () => {
  //   setShowAll(!showAll);
  //   setNumToShow(showAll ? 8 : products.length);
  // };

  const toggleShowAll = () => {
    if (isMobile) {
      if (numToShow >= products.length) {
        setNumToShow(2);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow((prev) => Math.min(prev + 10, products.length));
      }
    } else {
      if (showAll) {
        setNumToShow(5);
        setShowAll(false);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow(products.length);
        setShowAll(true);
      }
    }
  };

  useEffect(() => {
    // setShimmerLoader(true);
    getCategory();
  }, [id]);

  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleShowSort = () => {
    setShowSort(true);
    setShowFilter(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };

  const handleCloseSort = () => {
    setShowSort(false);
    setShowFilter(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="select-categories">
        <Container fluid>
          <div className="mb-4">
            <DoubleHeading heading="Category" />
          </div>

          <Tab.Container id="left-tabs-example" defaultActiveKey={id}>
            <Row className="me-0 ms-0 ">
              {shimmerLoader ? (
                <ShimmerThumbnail rounded />
              ) : // <div className="loader-container text-center my-5">
                //   <Loader_lottie />
                //   <p className="mt-2">Loading categories...</p>
                // </div>
                category.length > 0 ? (
                  <div variant="pills" className="flex-row p-0 mb-3">
                    <Swiper
                      className="mySwiper "
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      modules={[Pagination, Navigation]}
                      breakpoints={{
                        0: { slidesPerView: 2, spaceBetween: 10 },
                        320: { slidesPerView: 3, spaceBetween: 10 },
                        450: { slidesPerView: 3, spaceBetween: 10 },
                        486: { slidesPerView: 3, spaceBetween: 10 },
                        576: { slidesPerView: 4, spaceBetween: 10 },
                        768: { slidesPerView: 5, spaceBetween: 10 },
                        992: { slidesPerView: 6, spaceBetween: 10 },
                        1200: { slidesPerView: 8, spaceBetween: 10 },
                      }}>
                      {category?.map((slide, index) => (
                        <SwiperSlide key={index} className="product-slide">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={slide?.id}
                              onClick={() => handleCategoryClick(slide?.id)}>
                              <Popular_Product_Card
                                className="product-image"
                                content={slide?.name}
                                image={IMG_URL + slide?.image}
                                imgClassName="category-image"
                              />
                              <div className="triangle-right"></div>
                            </Nav.Link>
                          </Nav.Item>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                ) : (
                  <div className="empty-heading-holder">
                    <h3>No Categories Available</h3>
                  </div>
                )}

              {subCategory.length > 0 && (
                <div className="mt-3">
                  <DoubleHeading heading="All Sub Category" />
                  <div variant="pills" className="flex-row p-0  mb-3">
                    <Swiper
                      className="mySwiper"
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      modules={[Pagination, Navigation]}
                      breakpoints={{
                        0: { slidesPerView: 2, spaceBetween: 10 },
                        320: { slidesPerView: 3, spaceBetween: 10 },
                        450: { slidesPerView: 3, spaceBetween: 10 },
                        486: { slidesPerView: 3, spaceBetween: 10 },
                        576: { slidesPerView: 4, spaceBetween: 10 },
                        768: { slidesPerView: 5, spaceBetween: 10 },
                        992: { slidesPerView: 6, spaceBetween: 10 },
                        1200: { slidesPerView: 10, spaceBetween: 10 },
                      }}>
                      {Array.isArray(subCategory) &&
                        subCategory.map((slide, index) => (
                          <SwiperSlide key={index} className="product-slide">
                            <Nav.Item>
                              <Nav.Link
                                eventKey={slide?.id}
                                onClick={() =>
                                  handleSubCategoryClick(slide?.id)
                                }>
                                <Popular_Product_Card
                                  className="product-image"
                                  content={slide?.name}
                                  image={IMG_URL + slide?.image}
                                  imgClassName="category-image"
                                />
                                <div className="triangle-right"></div>
                              </Nav.Link>
                            </Nav.Item>
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
                </div>
              )}

              {/* Products Section */}
              <div ref={sectionRef}>
                {shimmerLoader ? (
                  <ShimmerThumbnail rounded />
                ) : (
                  // ) : products.length == 0 ? (
                  //   <div className="empty-heading-holder">
                  //     <h4>No Product With This Category</h4>
                  //   </div>
                  <>
                    {!isMobile && (
                      <div className="desktop_view_product_category_slider slider-holder">
                        <Row>
                          {products
                            .slice(0, numToShow)
                            .map((product, index) => {
                              const price =
                                product?.product_multiple_mains?.[0]
                                  ?.product_multiple_variants?.[0]?.mrp ||
                                product?.product_variants?.[0]?.mrp;

                              const cutprice =
                                product?.product_multiple_mains?.[0]
                                  ?.product_multiple_variants?.[0]
                                  ?.cutting_price ||
                                product?.product_variants?.[0]?.cutting_price;

                              return (
                                <Col
                                  key={index}
                                  xxl={3}
                                  xl={3}
                                  lg={3}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  className="custom_class_product">
                                  <Product_Card
                                    image={IMG_URL + product?.image1}
                                    text={product?.name}
                                    product_id={product?.id}
                                    subText={product?.short_description}
                                    price={price}
                                    cutprice={cutprice}
                                    newest={product?.newest}
                                    variant_id={
                                      product?.product_variants?.[0]?.id
                                    }
                                    m_variant_id={
                                      product?.product_multiple_mains?.[0]
                                        ?.product_multiple_variants?.[0]?.id
                                    }
                                  />
                                </Col>
                              );
                            })}
                        </Row>
                      </div>
                    )}

                    {/* MOBILE VIEW */}
                    {isMobile && (
                      <div className="mobile_view_product_category_slider">
                        <Row>
                          {products
                            .slice(0, numToShow)
                            .map((product, index) => {
                              const price =
                                product?.product_multiple_mains?.[0]
                                  ?.product_multiple_variants?.[0]?.mrp ||
                                product?.product_variants?.[0]?.mrp;

                              const cutprice =
                                product?.product_multiple_mains?.[0]
                                  ?.product_multiple_variants?.[0]
                                  ?.cutting_price ||
                                product?.product_variants?.[0]?.cutting_price;

                              return (
                                <Col
                                  key={index}
                                  xxl={3}
                                  xl={3}
                                  lg={3}
                                  md={4}
                                  sm={4}
                                  xs={6}
                                  className="custom_class_product">
                                  <Product_Card
                                    image={IMG_URL + product?.image1}
                                    text={product?.name}
                                    product_id={product?.id}
                                    subText={product?.short_description}
                                    price={price}
                                    cutprice={cutprice}
                                    newest={product?.newest}
                                    variant_id={
                                      product?.product_variants?.[0]?.id
                                    }
                                    m_variant_id={
                                      product?.product_multiple_mains?.[0]
                                        ?.product_multiple_variants?.[0]?.id
                                    }
                                  />
                                </Col>
                              );
                            })}
                        </Row>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* View All/ View Less Button */}
              {/* {products.length > 0 && (
                <div className="view-all mb-5" onClick={toggleShowAll}>
                  <p>
                    {isMobile
                      ? numToShow >= products.length
                        ? "View Less"
                        : "View More"
                      : showAll
                        ? "View Less"
                        : "View All"}
                  </p>
                </div>
              )} */}
            </Row>
          </Tab.Container>
        </Container>
      </section>

      {/* Pass props to control offcanvas */}
      <Filter_offcanvas show={showFilter} handleClose={handleClose} />
      {/* <Sort_offcanvas show={showSort} handleClose={handleCloseSort} /> */}
    </>
  );
};

export default SelectFromCategories;
